import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'

import type { IActivityRepository } from '../IActivityRepository'
import type { IBaseEntity } from '../../base/BaseEntity'

@InputType()
export class UpdateRemarksActivityMentionArgs extends ActionArgs {
  @Field(() => String, { nullable: false })
  parentId: string

  @Field(() => String, { nullable: false })
  remarksActivityId: string

  @Field(() => String)
  activity?: string

  @Field(() => Boolean)
  isDeleted?: boolean

  @Field(() => String)
  templateKey?: string

  @Field(() => String)
  url?: string
}

export type UpdateRemarksActivityMentionType<T extends IBaseEntity> = UpdateRemarksActivityMentionArgs & {
  activityRepository: IActivityRepository<T>
}

export interface IUpdateRemarksActivityMention<T extends IBaseEntity> extends IAction<T, UpdateRemarksActivityMentionType<T>> {}
